//#region Libraries
import { useState, useEffect } from "react";
//#endregion
//#region Styles
//#endregion
//#region Components
//#endregion
//#region Services
import { requestGetAcadReinforceList } from "services/acadReinforce/aboutAcadReinforce";
import { acadReinforcementSessionStorage } from "services/storage/acadReinforcement";
//#endregion
//#region Utils
import useMainContext from "utils/context/useMainContext";
//#endregion

const useAcadReinforceList = ({
    currentTabIdx, tabData,
    loadingRequest,
    fillTitleViews,
    paginator, filters
}) => {
    const mainContext = useMainContext();
    //#region States
    const [acadReinforceList, setAcadReinforceList] = useState([]);
    const [triggerRequest, setTriggerRequest] = useState(false);
    const [toSynchronize, setToSynchronize] = useState(false);
    const [fatalError, setFatalError] = useState(false);
    //#endregion
    useEffect(() => {
        if (!triggerRequest) return;
        fillAcadReinforceList();
        setTriggerRequest(false);
    }, [triggerRequest]);
    useEffect(() => {
        mainContext.reloadForUnexpectedError(fatalError);
    }, [mainContext.showDialogUnexpectedError]);
    //#region Functions
    const fillAcadReinforceList = async () => {
        const page = paginator.data.currentPage;
        // Setteando índice del tab actual en el localStorage
        acadReinforcementSessionStorage.currentTabIdxAcadReinforceList.set(currentTabIdx);
        //#region Cargando nueva lista
        loadingRequest.show();
        await fillTitleViews({
            date: filters.value.date, 
            page
        });
        try {
            const data = await requestGetAcadReinforceList({
                filterType: tabData.filterTypes[currentTabIdx],
                page,
                ...filters.value
            });
            setAcadReinforceList(data.acadReinforceList);
            setToSynchronize(data.toSynchronize);
        }
        catch (err) {
            setFatalError(true);
            mainContext.setShowDialogUnexpectedError(true);
        }
        finally { loadingRequest.hide(); }
        //#endregion
    }
    //#endregion
    return {
        value: acadReinforceList,
        fill: fillAcadReinforceList,
        triggerFill: () => setTriggerRequest(true), 
        fatalError,
        toSynchronize
    };
}

export default useAcadReinforceList;